// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner__spinner___3C2E-","spinning-cog":"Spinner__spinning-cog___2ZSes","white":"Spinner__white___ykPcp","black":"Spinner__black___2QIKg"};